import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'nwt-power-supply-name-dialog',
  template: 
  `
  <h1 mat-dialog-title>Power Supply Already Exists with Name {{powerSupplyName}}!!</h1>
  <mat-dialog-actions class="d-flex justify-content-center">
    <button mat-button type="button" (click)="ok()">OK</button>
  </mat-dialog-actions>
  `
})
export class PowerSupplyNameDialog implements OnInit {

  powerSupplyName: string = '';

  constructor(
    public dialogRef: MatDialogRef<PowerSupplyNameDialog>,
    @Inject(MAT_DIALOG_DATA) private data) {
      this.powerSupplyName = this.data.powerSupplyName;
  }

  ngOnInit() {
  }

  ok() {
    this.dialogRef.close('OK')
  }
}
